export default __webpack_public_path__ + "c50e9d7a3510784e3760e123224dcf04.pdf";